import React from 'react';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

class CookieConsent extends React.Component {
	state = {
		visible: false
	};

	componentDidMount() {
		const accepted = localStorage.getItem(COOKIE_CONSENT_KEY);

		if (!accepted) {
			this.setState({ visible: true });
		}
	}

	acceptCookies = () => {
		localStorage.setItem(COOKIE_CONSENT_KEY, 'true');

		this.setState({
			visible: false
		});
	};

	render() {
		if (!this.state.visible) {
			return null;
		}

		return (
			<div className="cookie-consent">
				<div className="cookie-consent__text">
					Продолжая использовать этот сайт Вы соглашаетесь с использованием
					cookie-файлов в соответствии с{' '}
					<a
						href="https://www.rentabox.ru/wp-content/uploads/2026/05/Политика-конфиденциальности_my_rentabox_ru.pdf"
						target="_blank"
						rel="noopener noreferrer"
					>
						Политикой конфиденциальности
					</a>{' '}
					и{' '}
					<a
						href="https://www.rentabox.ru/wp-content/uploads/2026/05/Согласие_пользователя_сайта_my_rentabox_ru.pdf"
						target="_blank"
						rel="noopener noreferrer"
					>
						Согласие на обработку персональных данных
					</a>.
				</div>

				<button
					className="cookie-consent__button"
					onClick={this.acceptCookies}
				>
					Принять
				</button>
			</div>
		);
	}
}

export default CookieConsent;
